import _PropTypes from 'prop-types';
import { startOfYear, addMonths, format } from 'date-fns';
import styled from 'styled-components';
import { range } from '../../../utils/util.js';
import { Button } from '../../Button/Button.js';
import { jsx } from 'react/jsx-runtime';

var StyledMonthRow = styled.div.withConfig({
  displayName: "DatePickerMonths__StyledMonthRow",
  componentId: "sc-1sex1iv-0"
})({
  display: "flex",
  justifyContent: "space-between",
  textAlign: "center",
  width: 224
});

var Months = function Months(_ref) {
  var datum = _ref.datum,
      locale = _ref.locale,
      _onClick = _ref.onClick;
  var start = startOfYear(datum);
  var monthsPerRow = 3;
  return /*#__PURE__*/jsx("div", {
    children: range(12 / monthsPerRow).map(function (i) {
      return /*#__PURE__*/jsx(StyledMonthRow, {
        children: range(monthsPerRow).map(function (j) {
          var offset = monthsPerRow * i + j;
          var nextDatum = addMonths(start, offset);
          return /*#__PURE__*/jsx(Button, {
            label: "Select month",
            onClick: function onClick() {
              return _onClick(nextDatum);
            },
            variant: "ghost",
            children: format(nextDatum, "MMM", {
              locale: locale
            })
          }, offset);
        })
      }, i);
    })
  });
};

Months.propTypes = {
  "datum": _PropTypes.instanceOf(Date).isRequired,
  "locale": _PropTypes.shape({
    "code": _PropTypes.string,
    "formatDistance": _PropTypes.func,
    "formatLong": _PropTypes.shape({
      "date": _PropTypes.func.isRequired,
      "dateTime": _PropTypes.func.isRequired,
      "time": _PropTypes.func.isRequired
    }),
    "formatRelative": _PropTypes.func,
    "localize": _PropTypes.shape({
      "day": _PropTypes.func.isRequired,
      "dayPeriod": _PropTypes.func.isRequired,
      "era": _PropTypes.func.isRequired,
      "month": _PropTypes.func.isRequired,
      "ordinalNumber": _PropTypes.func.isRequired,
      "quarter": _PropTypes.func.isRequired
    }),
    "match": _PropTypes.shape({
      "day": _PropTypes.func.isRequired,
      "dayPeriod": _PropTypes.func.isRequired,
      "era": _PropTypes.func.isRequired,
      "month": _PropTypes.func.isRequired,
      "ordinalNumber": _PropTypes.func.isRequired,
      "quarter": _PropTypes.func.isRequired
    }),
    "options": _PropTypes.shape({
      "firstWeekContainsDate": _PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7]),
      "weekStartsOn": _PropTypes.oneOf([0, 1, 2, 3, 4, 5, 6])
    })
  }),
  "onClick": _PropTypes.func.isRequired
};
Months.displayName = "Months";

export { Months };
